import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AsyncSelect from 'react-select/lib/Async';
import { Button } from 'react-bootstrap';

/**
 * ReactSelect @next documentation
 * https://deploy-preview-2289--react-select.netlify.com/home
 * Seems a little buggy, but should get less buggy soon, might
 * be good to keep this target, as the new API is much better.
 */

import Safe from './Safe';

const Criteria = ({ criteria }) => {
  const { type = '', value = '' } = criteria;
  return (
    <span>
      <span style={{ fontWeight: 300 }}>{`${type}:`}</span>
      <span style={{ fontWeight: 400 }}>{value}</span>
    </span>
  );
};

Criteria.propTypes = {
  criteria: PropTypes.shape({}),
};

Criteria.defaultProps = {
  criteria: {},
};

class CriteriaSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      criteria: props.criteria || [],
      activeType: 'asset',
      popupOpen: false,
    };

    this.entityTypes = {
      asset: {},
      assetType: {},
      tags: {},
      locations: {},
      src: {},
      dest: {},
    };

    this.applyCriteria = this.applyCriteria.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  getOptions(input, callback) {
    /**
     * @TODO: replace with API call
     */
    const items = [
      { type: 'asset', value: 'Firewall Alpha', label: 'Firewall Alpha' },
      { type: 'asset', value: 'Firewall A', label: 'Firewall A' },
      { type: 'asset', value: 'Ad Server', label: 'AD Sever' },
      { type: 'src', value: '172.17.10.199', label: '172.17.10.199' },
      { type: 'src', value: '192.168.1.1', label: '192.168.1.1' },
      { type: 'src', value: '192.168.1.19', label: '192.168.1.19' },
    ];
    setTimeout(() => {
      callback(_.filter(items, i =>
        i.type === this.state.activeType &&
        (
          i.value.toLowerCase().includes(input.toLowerCase()) ||
          i.label.toLowerCase().includes(input.toLowerCase())
        )));
    }, 500);
  }

  setType(type) {
    this.setState({ activeType: type });
  }

  applyCriteria() {
    const { applyFilter, fetch } = this.props;
    const { criteria = [] } = this.state;
    const newCriteria = criteria.slice();
    applyFilter('criteria', newCriteria);
    fetch();
    this.closePopup();
  }

  handleSelect(index, value) {
    let { criteria } = this.state;
    criteria = criteria.slice();
    criteria[index] = value;
    this.setState({ criteria });
  }

  handleChange() {
    const { criteria = [], activeType } = this.state;
    const newCriteria = _.filter(criteria.slice(), c => c.type !== activeType);
    const value = _.get(this.select, 'select.select.state.focusedOption', null); // @xxx react-select beta seems broken, value is empty
    if (value !== null) {
      newCriteria.push(value);
      this.setState({ criteria: newCriteria });
    }
  }

  togglePopup() {
    this.setState(state => ({ popupOpen: !state.popupOpen }));
  }

  openPopup() {
    this.setState({ popupOpen: true });
  }

  closePopup() {
    this.setState({ popupOpen: false });
  }

  render() {
    const { criteria = [], popupOpen } = this.state;
    return (
      <div className='filter-selection' data-popup-open={popupOpen}>
        <div className='filter-header'>
          <span className='text'>Criteria Selection:</span>
          <span className='input'>
            <span className='text' role='button' tabIndex={-1} onClick={this.togglePopup}>
              <Criteria criteria={criteria[0] || {}} />
            </span>
          </span>
          <span className='text'>and</span>
          <span className='input'>
            <span className='text' role='button' tabIndex={-1} onClick={this.togglePopup}>
              <Criteria criteria={criteria[1] || {}} />
            </span>
          </span>
          <span className='icon'>
            <i
              className='fas fa-list-ul'
              role='button'
              tabIndex={-1}
              onClick={this.togglePopup}
            />
          </span>
        </div>
        {popupOpen &&
          <div className='popup'>
            <i
              className='close fas fa-times'
              role='button'
              tabIndex={-1}
              onClick={this.closePopup}
            />
            <div className='content-wrapper'>
              <div
                className='type'
                style={{ width: '40%', display: 'inline-block', verticalAlign: 'top' }}
              >
                Select Entity Type
                <div
                  className='entityTypes'
                >
                  {_.map(Object.keys(this.entityTypes), t => (
                    <div
                      key={t}
                      role='button'
                      tabIndex={-1}
                      className={`button${this.state.activeType === t ? ' active' : ''}`}
                      onClick={this.setType.bind(this, t)}
                    >
                      <Safe
                        render
                        safe
                        path='entityTypes'
                        value={t}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div
                className='entity'
                style={{ width: '40%', display: 'inline-block', verticalAlign: 'top' }}
              >
                Select Entity
                <div
                  className='select'
                  style={{ marginTop: '9px' }}
                >
                  <AsyncSelect
                    ref={(c) => { this.select = c; }}
                    loadOptions={this.getOptions}
                    onInputChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <hr />
            <div style={{ width: '100%', padding: '0px 0px 15px', textAlign: 'center' }}>
              <Button className='btn btn-primary' onClick={this.applyCriteria.bind(this)}>Apply</Button>
            </div>
          </div>
        }
      </div>
    );
  }
}

CriteriaSelection.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  criteria: PropTypes.instanceOf(Array),
};

CriteriaSelection.defaultProps = {
  criteria: [],
};

export default CriteriaSelection;



// WEBPACK FOOTER //
// ./src/views/Components/CriteriaSelection.js